/* @flow */
import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import GroupActions from 'groups/actions/GroupActions';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import Message from 'entities/Message';
import openPopup from 'utils/openPopup';

import GroupMessageBase from './GroupMessageBase.jsx';
import GroupMessageContent from './GroupMessageContent.jsx';
import GroupMessageHeader from './GroupMessageHeader.jsx';
import GroupMessageInformation from './GroupMessageInformation.jsx';

const UI_CONTEXT = 'group_message';

class GroupMessage extends React.Component {
  static propTypes = {
    backgroundColor: React.PropTypes.string,
    border: React.PropTypes.bool,
    showReadReceipt: React.PropTypes.bool,
    iconUrl: React.PropTypes.string,
    message: React.PropTypes.instanceOf(Message).isRequired,
    groupId: React.PropTypes.number,
    groupIsOwnedByUser: React.PropTypes.bool,
  };

  static childContextTypes = {
    eventContextName: React.PropTypes.string,
  };

  static defaultProps = {
    border: true,
    iconUrl: null,
    showReadReceipt: true,
  };

  state = {
    hoverAction: false,
  };

  getChildContext() {
    return {
      eventContextName: UI_CONTEXT,
    };
  }

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    // 'message' never changes deeply, but it may get a new object even when
    // nothing changes. So this is safe, but not maximally performant.
    return shallowCompare(this, nextProps, nextState);
  }

  sendAgain = () => {
    window.scrollTo(0, 0);
    GroupActions.sendAgainGroupMessage(this.props.groupId, this.props.message);
  };

  tweet = () => {
    const { message } = this.props;

    let text = message.getBody();
    message.getFiles().forEach(file => {
      const fileUrl = file.getUrls().large || file.getUrls().cdn;
      text += ' ' + fileUrl;
    });
    text += ' (via remind.com)';

    const encodedText = encodeURIComponent(text);
    const url = `https://twitter.com/intent/tweet?text=${encodedText}`;

    openPopup(url, 'twitter');
  };

  renderHeaderActions = () => {
    const menu = (
      <Menu>
        {
          !CurrentUser.getUser().isUnderage() &&
          (<MenuItem onClick={() => this.tweet()}>
            Tweet
          </MenuItem>)
        }
        <MenuItem onClick={() => this.sendAgain()}>
          Send again
        </MenuItem>
      </Menu>
    );

    return (
      <div className="GroupMessageBase-headerActions">
        <LayerTrigger
          layer={menu}
          trigger="click"
          placement="bottom"
          alignment="middle">
          <Glyph color="koala" name="ellipses" size="large" solo />
        </LayerTrigger>
      </div>
    );
  };

  render() {
    const { message } = this.props;
    return (
      <GroupMessageBase
        className="GroupMessage"
        message={this.props.message}
        border={this.props.border}
        backgroundColor={this.props.backgroundColor}>
        <GroupMessageHeader
          ref="header"
          author={message && message.getSender().getName()}
          initials={message && message.getSender().getInitials()}
          color={message && message.getSender().getColor()}
          senderId={message && message.getSender().id}
          iconUrl={this.props.iconUrl}>
          {
            this.props.groupIsOwnedByUser &&
            this.renderHeaderActions()
          }
        </GroupMessageHeader>
        <GroupMessageContent />
        <GroupMessageInformation showReadReceipt={this.props.showReadReceipt} />
      </GroupMessageBase>
    );
  }
}

export default GroupMessage;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessage.jsx